/**
 * Singleton do `AccessOracle` para uso fora do contexto React.
 *
 * O `AccessOracleProvider` continua sendo a forma idiomática de consumir o
 * oracle dentro de componentes (via `useAccessOracle`). Este singleton
 * existe para hooks fora do React tree poderem chamar `oracle.clear()` —
 * notavelmente o `clearOfflineCaches` em `clearOfflineData.ts`.
 *
 * O bootstrap (em `main.tsx` ou wrapper de auth) chama `setAccessOracle`
 * após criar o oracle. Logout chama `setAccessOracle(null)`.
 */

import type { AccessOracle } from './accessOracle';

let current: AccessOracle | null = null;

export function setAccessOracle(oracle: AccessOracle | null): void {
  current = oracle;
}

export function getAccessOracle(): AccessOracle | null {
  return current;
}
